import SmartImage from "../../../components/reusables/smartImage";
import NoPictureWarning from "../../../resources/nopic.png";
import { formatCurrency } from "../../../utils/CurrencyUtils";

const ProductItemCard = ({ item, onClick }) => {
    const isParent = sessionStorage.getItem('role') === 'PARENT';
    const imageBaseUrl = `/foodz/api/v1/uploads/carregarImagemDoProduto?path=${encodeURIComponent(item.image_url)}`;

    return (
        <div
            onClick={() => onClick(item)}
            className="group relative aspect-square bg-slate-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 cursor-pointer border border-gray-100"
        >
            <div className="absolute inset-0 w-full h-full">
                {item.image_url ? (
                    <SmartImage
                        src={imageBaseUrl}
                        alt={item.name}
                        isThumb={true}
                        className="object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                ) : (
                    <img
                        src={NoPictureWarning}
                        className="absolute inset-0 w-full h-full object-contain p-10 opacity-20"
                        alt="Sem foto"
                    />
                )}
            </div>

            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent opacity-90" />

            <div className="absolute top-3 left-3 right-3 z-10 flex flex-wrap gap-1.5">
                {!isParent && (
                    <span className={`px-2 py-0.5 rounded-full text-[9px] font-bold text-white shadow-sm ${item.active ? 'bg-green-500' : 'bg-red-500'}`}>
                        {item.active ? 'ATIVO' : 'INATIVO'}
                    </span>
                )}

                {!isParent && (
                    <span className="px-2 py-0.5 rounded-full text-[9px] font-bold bg-custom_blue text-white shadow-sm border border-white/10 uppercase">
                        {item.category || 'Estoque'}
                    </span>
                )}

                {!isParent && item.quantity <= (item.limit_warning || 5) && (
                    <span className="px-2 py-0.5 rounded-full text-[9px] font-bold bg-amber-500 text-white shadow-sm border border-white/10">
                        ESTOQUE BAIXO
                    </span>
                )}
            </div>

            <div className="absolute bottom-0 left-0 w-full p-4 text-white z-10">
                <p className="font-bold text-base leading-tight truncate mb-1 drop-shadow-md">{item.name}</p>
                <div className="flex justify-between items-center border-t border-white/10 pt-2">
                    {!isParent ?
                        <>
                            <span className="text-green-400 font-bold text-sm">{formatCurrency(item.price)}</span>
                            <div className="text-right">
                                <span className="text-[10px] text-gray-300 uppercase tracking-tighter font-medium block">Disp: {item.quantity}</span>
                                {item.reserved_quantity > 0 && (
                                    <span className="text-[10px] text-amber-300 uppercase tracking-tighter font-medium block">Res: {item.reserved_quantity}</span>
                                )}
                            </div>
                        </>
                        :
                        <>
                            <span className="text-green-400 font-bold text-sm">{formatCurrency(item.online_price)}</span>
                            <span className="text-[10px] text-gray-300 uppercase tracking-tighter font-medium">Qtd: {item.quantity}</span>
                        </>
                    }
                </div>
            </div>
        </div>
    );
};

export default ProductItemCard;